import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ForgotPasswordService } from '../../services/ForgotPassword.service';
import { AlertMessages, AlertType } from '../../../../core/AlertMessages';


@Component({
  selector: 'app-forgot-change-password',
  templateUrl: './forgot-change-password.component.html',
  styleUrls: ['./forgot-change-password.component.css']
})

export class ForgotChangePasswordComponent implements OnInit {

  constructor(private Router: Router, private _route: ActivatedRoute, private service: ForgotPasswordService) {}
  linkCode: string;
  panelType: string;
  isSubmitError: boolean = false;
  isSubmitSuccess: boolean = false;
  errorMessage: string;
  password: string = "";
  cPassword: string = "";
  showExpire: boolean = false;
  linkMessage: string = "";

  ngOnInit() {
    this._route.queryParams.subscribe(params => {
      this.linkCode = params['LinkCode'];
      this.panelType = params['Panel'];
    });
    if (this.linkCode == undefined || this.linkCode == null || this.linkCode == "" || this.panelType == undefined || this.panelType == null || this.panelType == "") {
      this.showExpire = true;
    } else {
      this.showExpire = false;
      this.checkLink(this.panelType, this.linkCode);
    }
  }

  checkLink(panelType, linkCode) {
    this.service.checkLink(panelType, linkCode).subscribe((data: any) => {
      if (data.Status == 0) {
        this.showExpire = true;
      } else {
        this.showExpire = false;
        this.linkMessage = "";
        this.linkMessage = this.panelType == "2" ? "Change Password For HA " + " ( " + data.Username + " ) " : this.panelType == "4" ? "Change Password For PA " + " ( " + data.Username + " ) " : "";

      }
    });
  }

  alertClose() {
    setTimeout(() => {
      this.isSubmitSuccess = false;
      this.Router.navigate(['login']);
    }, 1000);
  }

  onSubmit(passwordForm) {
    this.service.changeForgotPassword(passwordForm.value.password, this.linkCode, this.panelType).subscribe(
    (data) => {
      passwordForm.reset();
      if (data["Id"] == 1) {
        this.isSubmitSuccess = true;
        this.errorMessage = data["StatusMessage"];
        this.alertClose();
        AlertMessages.Show('Success','submitted successfully', AlertType.Success);

      }

    },
    (error) => {
        this.isSubmitError = true;
        if(error.error.length > 0) {
          alert(error.error[0]);
          this.errorMessage = error.error[0];
        AlertMessages.Show('Failed',error.error[0], AlertType.Error);


        }
    });
  }

  routeToCodes() {
    this.Router.navigate(['login']);
  }

}
